/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The EventsControllerDtoRaffleInfoResponse model module.
 * @module model/EventsControllerDtoRaffleInfoResponse
 * @version 1.0
 */
class EventsControllerDtoRaffleInfoResponse {
    /**
     * Constructs a new <code>EventsControllerDtoRaffleInfoResponse</code>.
     * @alias module:model/EventsControllerDtoRaffleInfoResponse
     */
    constructor() { 
        
        EventsControllerDtoRaffleInfoResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoRaffleInfoResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoRaffleInfoResponse} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoRaffleInfoResponse} The populated <code>EventsControllerDtoRaffleInfoResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoRaffleInfoResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('itemDrawStartAt')) {
                obj['itemDrawStartAt'] = ApiClient.convertToType(data['itemDrawStartAt'], 'Date');
            }
            if (data.hasOwnProperty('itemDrawEndAt')) {
                obj['itemDrawEndAt'] = ApiClient.convertToType(data['itemDrawEndAt'], 'Date');
            }
            if (data.hasOwnProperty('ticketRequiredCount')) {
                obj['ticketRequiredCount'] = ApiClient.convertToType(data['ticketRequiredCount'], 'Number');
            }
            if (data.hasOwnProperty('ticketItems')) {
                obj['ticketItems'] = ApiClient.convertToType(data['ticketItems'], 'String');
            }
            if (data.hasOwnProperty('jsonRoundInfo')) {
                obj['jsonRoundInfo'] = ApiClient.convertToType(data['jsonRoundInfo'], 'String');
            }
            if (data.hasOwnProperty('jsonRewardInfo')) {
                obj['jsonRewardInfo'] = ApiClient.convertToType(data['jsonRewardInfo'], 'String');
            }
            if (data.hasOwnProperty('jsonBonusReward')) {
                obj['jsonBonusReward'] = ApiClient.convertToType(data['jsonBonusReward'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoRaffleInfoResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoRaffleInfoResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['ticketItems'] && !(typeof data['ticketItems'] === 'string' || data['ticketItems'] instanceof String)) {
            throw new Error("Expected the field `ticketItems` to be a primitive type in the JSON string but got " + data['ticketItems']);
        }
        // ensure the json data is a string
        if (data['jsonRoundInfo'] && !(typeof data['jsonRoundInfo'] === 'string' || data['jsonRoundInfo'] instanceof String)) {
            throw new Error("Expected the field `jsonRoundInfo` to be a primitive type in the JSON string but got " + data['jsonRoundInfo']);
        }
        // ensure the json data is a string
        if (data['jsonRewardInfo'] && !(typeof data['jsonRewardInfo'] === 'string' || data['jsonRewardInfo'] instanceof String)) {
            throw new Error("Expected the field `jsonRewardInfo` to be a primitive type in the JSON string but got " + data['jsonRewardInfo']);
        }
        // ensure the json data is a string
        if (data['jsonBonusReward'] && !(typeof data['jsonBonusReward'] === 'string' || data['jsonBonusReward'] instanceof String)) {
            throw new Error("Expected the field `jsonBonusReward` to be a primitive type in the JSON string but got " + data['jsonBonusReward']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
EventsControllerDtoRaffleInfoResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
EventsControllerDtoRaffleInfoResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
EventsControllerDtoRaffleInfoResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
EventsControllerDtoRaffleInfoResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
EventsControllerDtoRaffleInfoResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoRaffleInfoResponse.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoRaffleInfoResponse.prototype['endAt'] = undefined;

/**
 * @member {Date} itemDrawStartAt
 */
EventsControllerDtoRaffleInfoResponse.prototype['itemDrawStartAt'] = undefined;

/**
 * @member {Date} itemDrawEndAt
 */
EventsControllerDtoRaffleInfoResponse.prototype['itemDrawEndAt'] = undefined;

/**
 * @member {Number} ticketRequiredCount
 */
EventsControllerDtoRaffleInfoResponse.prototype['ticketRequiredCount'] = undefined;

/**
 * @member {String} ticketItems
 */
EventsControllerDtoRaffleInfoResponse.prototype['ticketItems'] = undefined;

/**
 * @member {String} jsonRoundInfo
 */
EventsControllerDtoRaffleInfoResponse.prototype['jsonRoundInfo'] = undefined;

/**
 * @member {String} jsonRewardInfo
 */
EventsControllerDtoRaffleInfoResponse.prototype['jsonRewardInfo'] = undefined;

/**
 * @member {String} jsonBonusReward
 */
EventsControllerDtoRaffleInfoResponse.prototype['jsonBonusReward'] = undefined;






export default EventsControllerDtoRaffleInfoResponse;

